module.exports = __webpack_public_path__ + "static/media/peru.e6cc1a45.svg";